import { FieldPropsConfig } from 'ui/forms/custom/types';

import { commonFieldsProps } from '../common/fields';

export const BGFieldProps: Record<string, FieldPropsConfig> = {
  ...commonFieldsProps,
  phone: {
    fieldType: 'input',
    pattern:
      '^(?:(?:\\(?(?:0(?:0|11)\\)?[\\s-]?\\(?|\\+)44\\)?[\\s-]?(?:\\(?0\\)?[\\s-]?)?)|(?:\\(?0))(?:(?:\\d{5}\\)?[\\s-]?\\d{4,5})|(?:\\d{4}\\)?[\\s-]?(?:\\d{5}|\\d{3}[\\s-]?\\d{3}))|(?:\\d{3}\\)?[\\s-]?\\d{3}[\\s-]?\\d{3,4})|(?:\\d{2}\\)?[\\s-]?\\d{4}[\\s-]?\\d{4}))(?:[\\s-]?(?:x|ext\\.?|\\#)\\d{3,4})?$',
  },
  phoneNumber: {
    fieldType: 'input',
    pattern:
      '^(?:(?:\\(?(?:0(?:0|11)\\)?[\\s-]?\\(?|\\+)44\\)?[\\s-]?(?:\\(?0\\)?[\\s-]?)?)|(?:\\(?0))(?:(?:\\d{5}\\)?[\\s-]?\\d{4,5})|(?:\\d{4}\\)?[\\s-]?(?:\\d{5}|\\d{3}[\\s-]?\\d{3}))|(?:\\d{3}\\)?[\\s-]?\\d{3}[\\s-]?\\d{3,4})|(?:\\d{2}\\)?[\\s-]?\\d{4}[\\s-]?\\d{4}))(?:[\\s-]?(?:x|ext\\.?|\\#)\\d{3,4})?$',
  },
  password: {
    fieldType: 'password',
    validations: ['password'],
    maxLength: 255,
  },
  newPassword: {
    fieldType: 'password',
    validations: ['password'],
    maxLength: 255,
  },
  currentPassword: {
    fieldType: 'password',
    maxLength: 255,
  },
  passwordConfirmation: {
    fieldType: 'password',
    validations: ['password'],
    maxLength: 255,
  },
  newPasswordConfirmation: {
    fieldType: 'password',
    validations: ['password'],
    maxLength: 255,
  },
  newResetPassword: {
    fieldType: 'password',
    validations: ['password'],
    maxLength: 255,
  },
  newResetPasswordConfirmation: {
    fieldType: 'password',
    validations: ['password'],
    maxLength: 255,
  },
  cancelLink: {
    fieldType: 'link',
    href: '/account',
  },
  countryCode: {
    fieldType: 'dropdown',
    validations: [],
    disabled: true,
    options: [{ label: 'Bulgaria', value: 'BG' }],
  },
  streetNumber: {
    fieldType: 'google-address-look-up',
    mapAddressLookupResultsToFormValues: [
      {
        resultKey: 'streetNumber',
        formKey: 'streetNumber',
      },
      {
        resultKey: 'street',
        formKey: 'address1',
      },
      {
        resultKey: 'city',
        formKey: 'city',
      },
      {
        resultKey: 'postalCode',
        formKey: 'postalCode',
      },
    ],
    validateOnAddressLookupSelect: false,
    maxLength: 30,
    submitOnUpdate: false,
    validations: ['latinLettersOnly'],
  },
  postalCode: {
    fieldType: 'input',
    autoCapitalize: 'characters',
    minLength: 4,
    maxLength: 10,
    validations: ['postalCode'],
  },
  billingPostalCode: {
    fieldType: 'input',
    autoCapitalize: 'characters',
    minLength: 4,
    maxLength: 10,
    pattern:
      '^(([gG][iI][rR] {0,}0[aA]{2})|(([aA][sS][cC][nN]|[sS][tT][hH][lL]|[tT][dD][cC][uU]|[bB][bB][nN][dD]|[bB][iI][qQ][qQ]|[fF][iI][qQ][qQ]|[pP][cC][rR][nN]|[sS][iI][qQ][qQ]|[iT][kK][cC][aA]) {0,}1[zZ]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yxA-HK-XY]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$',
  },
  firstName: {
    fieldType: 'input',
    validations: ['englishLettersOnly'],
    maxLength: 30,
  },
  lastName: {
    fieldType: 'input',
    validations: ['englishLettersOnly'],
    maxLength: 30,
  },
  companyName: {
    fieldType: 'input',
    validations: ['latinLettersOnly'],
    maxLength: 50,
  },
  address1: {
    fieldType: 'input',
    validations: ['latinLettersOnly'],
    maxLength: 50,
  },
  address2: {
    fieldType: 'input',
    validations: ['latinLettersOnly'],
    maxLength: 50,
  },
  city: {
    fieldType: 'input',
    validations: ['latinLettersOnly'],
    maxLength: 50,
  },
};
